export enum DocInfoExtendEventsKeys {
    USER_INFO_READY_EVENT = 'UserInfoReadyEvent',
}

export interface DocInfoExtendEventsMap {
    [DocInfoExtendEventsKeys.USER_INFO_READY_EVENT]: any;
}
